import { Grid } from "@mui/material";
import { ThreeCardsMarkup } from "./ThreeCardsMarkup";
import { TwoCardsMarkup } from "./TwoCardsMarkup";

export const PrepForBlockResult = ({ apart, textPaycheck, CustomBox, fullName, saveFullApartSquare }) => {
  return (
    <>
      {apart.data.map((block, index) => (
        <Grid
          key={index}
          container
          spacing="18px"
          justifyContent="center"
          mt={2}
        >
          {Object.hasOwn(block, "totalArea") ? (
            <TwoCardsMarkup
              block={block}
              textPaycheck={textPaycheck}
              CustomBox={CustomBox}
              fullName={fullName}
              saveFullApartSquare={saveFullApartSquare}
            />
          ) : (
            <ThreeCardsMarkup
              block={block}
              textPaycheck={textPaycheck}
              CustomBox={CustomBox}
            />
          )}
        </Grid>
      ))}
    </>
  );
};


{
  /* <OccupancyRate
          occupancy={block.occupancy}
          CustomBox={CustomBox}
        />
        <AverageTarif averageTarif={block.averageTarif} CustomBox={CustomBox} />
        <PaycheckComplete
          text={textPaycheck}
          income={block.income}
          CustomBox={CustomBox}
        /> */
}
